import { flagNumber, ID_DOC_QUALITY_FLAGS } from "../../../utils/featureFlags";

// ── Adjustable quality-gate thresholds (v2 / assisted) ──
//
// Three layers, later wins, each optional:
//   1. journey setting  settings.journey.settings.docCaptureQuality
//      { blurMin, blurMinAndroid, blurMinIos, glareMax, lumaMin, lumaMax, lumaStdMin, darkRoom, motionMax, holdMs }
//      (blurMinAndroid / blurMinIos win over blurMin on their platform)
//      (motionMax = max frame-to-frame change in the motion reading, i.e. the steady gate)
//   2. Flagship numeric flags (ID_DOC_QUALITY_FLAGS), session-sticky
//   3. ?doc_quality=blurMin:60,glareMax:0.1,holdMs:5000 for testing
// Unset keys fall through to the assisted preset in useDocumentDetection.
// Every resolved value is reported with its source so a dashboard can
// tell a tuned session from a default one.
export const QUALITY_KEYS = ["blurMin", "blurMinAndroid", "blurMinIos", "glareMax", "glareMaxBack", "lumaMin", "lumaMax", "lumaStdMin", "darkRoom", "motionMax", "holdMs"];

export function resolveQualityOverrides(settings) {
  const overrides = {};
  const sources = {};
  const take = (key, raw, source) => {
    const n = typeof raw === "string" ? Number(raw) : raw;
    if (typeof n !== "number" || !Number.isFinite(n) || n < 0) return;
    overrides[key] = n;
    sources[key] = source;
  };

  const fromJourney = settings?.journey?.settings?.docCaptureQuality;
  if (fromJourney && typeof fromJourney === "object") {
    QUALITY_KEYS.forEach((key) => take(key, fromJourney[key], "journey"));
  }

  QUALITY_KEYS.forEach((key) => {
    const flagName = ID_DOC_QUALITY_FLAGS[key];
    const fromSettings = settings?.feature_flags?.[flagName];
    const v = fromSettings !== undefined ? fromSettings : flagNumber(flagName, null);
    if (v !== undefined && v !== null) take(key, v, "flag");
  });

  try {
    const raw = new URLSearchParams(window.location.search).get("doc_quality");
    if (raw) {
      raw.split(",").forEach((pair) => {
        const [key, value] = pair.split(":");
        if (QUALITY_KEYS.includes(key)) take(key, value, "url");
      });
    }
  } catch {
    // no window / bad URL
  }

  return { overrides, sources };
}
